import { SystemConstants } from "src/common/constants";

const GET_EMPLOYERS = 'GET_EMPLOYERS';
export const GET_EMPLOYERS_API = GET_EMPLOYERS + SystemConstants.API_LOADER.TRIGGER_SUFFIX;
export const GET_EMPLOYERS_SUCCESS = GET_EMPLOYERS + SystemConstants.API_LOADER.SUCCESS_SUFFIX;
export const GET_EMPLOYERS_ERROR = GET_EMPLOYERS + SystemConstants.API_LOADER.ERROR_SUFFIX;